import emailjs from 'emailjs-com';

export function sendRegistrationEmail({
  user_name,
  registration_number,
  user_email,
  user_type,
  name,
  email,
}) {
  if (!email) {
    throw new Error("Recipient email (email) is empty");
  }
  return emailjs.send(
    'service_5tcb228',
    'template_gk26glr',
    {
      user_name,
      registration_number,
      user_email,
      user_type,
      name,
      email, // must match template variable!
    },
    '_i_23nZZB1-fY8buk'
  ).then(
    (result) => {
      console.log("EmailJS success:", result);
      return result;
    },
    (error) => {
      console.error("EmailJS error:", error);
      throw error;
    }
  );
}